// export const STATUS_CONFIG = {
//     Present: { text: "#4CAF50", bg: "rgba(76,175,80,0.10)" },
//     Absent: { text: "#F44336", bg: "rgba(244,67,54,0.10)" },
//     "Half Day": { text: "#FF9800", bg: "rgba(255,152,0,0.10)" },
//     "P/2": { text: "#FF9800", bg: "rgba(255,152,0,0.10)" }, // ← add this
//     "Week Off": { text: "#2196F3", bg: "rgba(33,150,243,0.10)" },
//     Holiday: { text: "#2196F3", bg: "rgba(33,150,243,0.10)" },
//     "Miss Punch": { text: "#FF5722", bg: "rgba(255,87,34,0.10)" },
//     Pending: { text: "#FF9800", bg: "rgba(255,152,0,0.10)" },
//     "Extra Work": { text: "#2E7D32", bg: "rgba(46,125,50,0.10)" },
// };

// export const getStatusCfg = (status) =>
//     STATUS_CONFIG[status] || { text: "#888", bg: "rgba(136,136,136,0.10)" };

// export const MONTH_NAMES = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
// ];

// export const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

// export function parseDate(dateStr) {
//     const d = new Date(dateStr);
//     return {
//         dayNum: String(d.getDate()).padStart(2, "0"),
//         monthShort: MONTH_NAMES[d.getMonth()].slice(0, 3).toUpperCase(),
//         dayName: DAY_NAMES[d.getDay()],
//     };
// }

// export function calcSummary(records) {
//     return records.reduce(
//         (acc, r) => {
//             console.log("show =====>", r);
//             const status = (r.status || "").trim();
//             const lowerStatus = status.toLowerCase();

//             // Attendance Summary
//             if (lowerStatus === "present") {
//                 acc.present++;
//             } else if (lowerStatus === "absent") {
//                 acc.absent++;
//             } else if (
//                 lowerStatus === "p/2" ||
//                 lowerStatus === "half day" ||
//                 lowerStatus.includes("half")
//             ) {
//                 acc.half++;
//             } else if (
//                 lowerStatus.includes("week off") &&
//                 !lowerStatus.includes("work")
//             ) {
//                 acc.weekOff++;
//             } else if (
//                 lowerStatus.includes("holiday") &&
//                 !lowerStatus.includes("work")
//             ) {
//                 acc.holiday++;
//             } else if (lowerStatus === "extra work") {
//                 acc.extra++;
//             }
//             // Miss Punch
//             else if (
//                 r.inTime &&
//                 r.inTime !== "--" &&
//                 r.inTime !== "NA" &&
//                 (!r.outTime || r.outTime === "--" || r.outTime === "NA")
//             ) {
//                 acc.missPunch++;
//             }
//             // Fallback Present
//             else if (
//                 r.inTime &&
//                 r.inTime !== "--" &&
//                 r.inTime !== "NA" &&
//                 r.outTime &&
//                 r.outTime !== "--" &&
//                 r.outTime !== "NA"
//             ) {
//                 acc.present++;
//             }
//             // Default Absent
//             else {
//                 acc.absent++;
//             }

//             // Pending Verification (separate count)
//             if (r.travelFlagged === true) {
//                 acc.pending++;
//             }

//             return acc;
//         },
//         {
//             present: 0,
//             absent: 0,
//             half: 0,
//             weekOff: 0,
//             holiday: 0,
//             missPunch: 0,
//             pending: 0,
//             extra: 0,
//         },
//     );
// }

// statusHelpers.js

export const STATUS_CONFIG = {
    Present: { text: "#4CAF50", bg: "rgba(76,175,80,0.10)" },
    Absent: { text: "#F44336", bg: "rgba(244,67,54,0.10)" },
    "Half Day": { text: "#FF9800", bg: "rgba(255,152,0,0.10)" },
    "P/2": { text: "#FF9800", bg: "rgba(255,152,0,0.10)" },
    "Week Off": { text: "#2196F3", bg: "rgba(33,150,243,0.10)" },
    "Week-off: Sunday": { text: "#2196F3", bg: "rgba(33,150,243,0.10)" }, // ← add
    "Week-off: Saturday": { text: "#2196F3", bg: "rgba(33,150,243,0.10)" }, // ← add
    Holiday: { text: "#2196F3", bg: "rgba(33,150,243,0.10)" },
    "Miss Punch": { text: "#FF5722", bg: "rgba(255,87,34,0.10)" },
    Pending: { text: "#FF9800", bg: "rgba(255,152,0,0.10)" },
    "Extra Work": { text: "#2E7D32", bg: "rgba(46,125,50,0.10)" },
};

export const getStatusCfg = (status) =>
    STATUS_CONFIG[status] || { text: "#888", bg: "rgba(136,136,136,0.10)" };

export const MONTH_NAMES = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

export const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export function parseDate(dateStr) {
    const d = new Date(dateStr);
    return {
        dayNum: String(d.getDate()).padStart(2, "0"),
        monthShort: MONTH_NAMES[d.getMonth()].slice(0, 3).toUpperCase(),
        dayName: DAY_NAMES[d.getDay()],
    };
}


 
export function calcSummary(records) {
    // console.log("recored ",records)
    return records.reduce(

        (acc, r) => {
            const status = (r.status || "").trim();
            const s = status.toLowerCase();

            if (s === "present") {
                acc.present++;
            } else if (s === "absent") {
                acc.absent++;
            } else if (s === "miss punch") {
                acc.missPunch++;
            } else if (s === "p/2" || s === "half day" || s.includes("half")) {
                acc.half++;
            } else if (s.includes("week off") || s.includes("week-off")) {
                acc.weekOff++;
            } else if (s.includes("holiday")) {
                acc.holiday++;
            } else if (s === "extra work") {
                acc.extra++;
            } else {
                // Any unrecognised status with no punches → absent
                acc.absent++;
            }

            // Pending verification is a separate dimension (travel flag)
            if (r.travelFlagged === true) {
                acc.pending++;
            }

            return acc;
        },
        {
            present: 0,
            absent: 0,
            half: 0,
            weekOff: 0,
            holiday: 0,
            missPunch: 0,
            pending: 0,
            extra: 0,
        },
    );
}
